<div>
    <div>
        <h5 class="c-label">Group Header</h5>
        <div class="row">
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="headerBackgroundColor">Background Color</label></div>
                    <div
                        class="input-group"
                        [(colorPicker)]="assetSetUp.header.backgroundColor"
                        [cpAlphaChannel]="'disabled'"
                        [cpOutputFormat]="'hex'"
                    >
                        <input id="headerBackgroundColor"
                            cclFormInput
                            type="text"
                            [(ngModel)]="assetSetUp.header.backgroundColor"
                            class="c-c-form-group__input form-control"
                        />

                        <div class="input-group-append">
                            <span
                                class="c-color-picker input-group-text"
                                [ngStyle]="{ 'background-color': assetSetUp.header.backgroundColor }"
                                >&nbsp;</span
                            >
                        </div>
                    </div>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="headerFontColor">Font Color</label></div>
                    <div
                        class="input-group"
                        [(colorPicker)]="assetSetUp.header.fontColor"
                        [cpAlphaChannel]="'disabled'"
                        [cpOutputFormat]="'hex'"
                        [cpPosition]="'left'"
                    >
                        <input id="headerFontColor"
                            cclFormInput
                            type="text"
                            [(ngModel)]="assetSetUp.header.fontColor"
                            class="c-c-form-group__input form-control"
                        />

                        <div class="input-group-append">
                            <span
                                class="c-color-picker input-group-text"
                                [ngStyle]="{ 'background-color': assetSetUp.header.fontColor }"
                                >&nbsp;</span
                            >
                        </div>
                    </div>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="fontStyle">Font Style</label></div>
                    <ccl-simple-select formId="fontStyle"
                        [listOfItems]="sharedService.fontStyles"
                        (valueChange)="assetSetUp.header.fontStyle = $event.value"
                        [value]="assetSetUp.header.fontStyle"
                        [bindValue]="'id'"
                        [bindLabel]="'label'"
                        [isClearable]="false"
                    ></ccl-simple-select>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="fontSize">Font Size</label></div>
                    <ccl-simple-select formId="fontSize"
                        [listOfItems]="sharedService.fontSizesSmall"
                        (valueChange)="assetSetUp.header.fontSize = $event.value"
                        [value]="assetSetUp.header.fontSize"
                    ></ccl-simple-select>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
        </div>
    </div>

    <div>
        <h5 class="c-label">Document Name</h5>
        <div class="row">
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="bodyBackgroundColor">Background Color</label></div>
                    <div
                        class="input-group"
                        [(colorPicker)]="assetSetUp.body.backgroundColor"
                        [cpAlphaChannel]="'disabled'"
                        [cpOutputFormat]="'hex'"
                        [cpPosition]="'right'"
                    >
                        <input id="bodyBackgroundColor"
                            cclFormInput
                            type="text"
                            [(ngModel)]="assetSetUp.body.backgroundColor"
                            class="c-c-form-group__input form-control"
                        />

                        <div class="input-group-append">
                            <span
                                class="c-color-picker input-group-text"
                                [ngStyle]="{ 'background-color': assetSetUp.body.backgroundColor }"
                                >&nbsp;</span
                            >
                        </div>
                    </div>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="bodyFontColor">Font Color</label></div>
                    <div
                        class="input-group"
                        [(colorPicker)]="assetSetUp.body.fontColor"
                        [cpAlphaChannel]="'disabled'"
                        [cpOutputFormat]="'hex'"
                        [cpPosition]="'left'"
                    >
                        <input id="bodyFontColor"
                            cclFormInput
                            type="text"
                            [(ngModel)]="assetSetUp.body.fontColor"
                            class="c-c-form-group__input form-control"
                        />

                        <div class="input-group-append">
                            <span
                                class="c-color-picker input-group-text"
                                [ngStyle]="{ 'background-color': assetSetUp.body.fontColor }"
                                >&nbsp;</span
                            >
                        </div>
                    </div>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="selectionMachanism">Font Style</label></div>
                    <ccl-simple-select ariaLabel="Font style"
                        [listOfItems]="sharedService.fontStyles"
                        (valueChange)="assetSetUp.body.fontStyle = $event.value"
                        [value]="assetSetUp.body.fontStyle"
                        [bindValue]="'id'"
                        [bindLabel]="'label'"
                        [isClearable]="false"
                    ></ccl-simple-select>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="expansionStyle">Font Size</label></div>
                    <ccl-simple-select ariaLabel="Font size"
                        [listOfItems]="sharedService.fontSizesSmall"
                        (valueChange)="assetSetUp.body.fontSize = $event.value"
                        [value]="assetSetUp.body.fontSize"
                        [bindValue]="'id'"
                        [bindLabel]="'label'"
                    ></ccl-simple-select>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
        </div>
    </div>

    <div>
        <h5 class="c-label">Download Button</h5>
        <div class="row">
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="bodyBackgroundColor">Background Color</label></div>
                    <div
                        class="input-group"
                        [(colorPicker)]="assetSetUp.download.backgroundColor"
                        [cpAlphaChannel]="'disabled'"
                        [cpOutputFormat]="'hex'"
                        [cpPosition]="'right'"
                    >
                        <input id="bodyBackgroundColor"
                            cclFormInput
                            type="text"
                            [(ngModel)]="assetSetUp.download.backgroundColor"
                            class="c-c-form-group__input form-control"
                        />

                        <div class="input-group-append">
                            <span
                                class="c-color-picker input-group-text"
                                [ngStyle]="{ 'background-color': assetSetUp.download.backgroundColor }"
                                >&nbsp;</span
                            >
                        </div>
                    </div>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="bodyFontColor">Font Color</label></div>
                    <div
                        class="input-group"
                        [(colorPicker)]="assetSetUp.download.fontColor"
                        [cpAlphaChannel]="'disabled'"
                        [cpOutputFormat]="'hex'"
                        [cpPosition]="'left'"
                    >
                        <input id="bodyFontColor"
                            cclFormInput
                            type="text"
                            [(ngModel)]="assetSetUp.download.fontColor"
                            class="c-c-form-group__input form-control"
                        />

                        <div class="input-group-append">
                            <span
                                class="c-color-picker input-group-text"
                                [ngStyle]="{ 'background-color': assetSetUp.download.fontColor }"
                                >&nbsp;</span
                            >
                        </div>
                    </div>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="selectionMachanism">Font Style</label></div>
                    <ccl-simple-select ariaLabel="Font style"
                        [listOfItems]="sharedService.fontStyles"
                        (valueChange)="assetSetUp.download.fontStyle = $event.value"
                        [value]="assetSetUp.download.fontStyle"
                        [bindValue]="'id'"
                        [bindLabel]="'label'"
                        [isClearable]="false"
                    ></ccl-simple-select>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="expansionStyle">Font Size</label></div>
                    <ccl-simple-select ariaLabel="Font size"
                        [listOfItems]="sharedService.fontSizesSmall"
                        (valueChange)="assetSetUp.download.fontSize = $event.value"
                        [value]="assetSetUp.download.fontSize"
                        [bindValue]="'id'"
                        [bindLabel]="'label'"
                    ></ccl-simple-select>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
        </div>
    </div>

    <div>
        <h5 class="c-label">Row</h5>
        <div class="row">
            <div class="col-sm-6">
                <div class="c-form-group">
                    <div class="c-form-group__label"><label for="bodyBackgroundColor">Background Color</label></div>
                    <div
                        class="input-group"
                        [(colorPicker)]="assetSetUp.row.backgroundColor"
                        [cpAlphaChannel]="'disabled'"
                        [cpOutputFormat]="'hex'"
                        [cpPosition]="'top'"
                    >
                        <input id="bodyBackgroundColor"
                            cclFormInput
                            type="text"
                            [(ngModel)]="assetSetUp.row.backgroundColor"
                            class="c-c-form-group__input form-control"
                        />

                        <div class="input-group-append">
                            <span
                                class="c-color-picker input-group-text"
                                [ngStyle]="{ 'background-color': assetSetUp.row.backgroundColor }"
                                >&nbsp;</span
                            >
                        </div>
                    </div>
                    <div class="c-form-group__hint">&nbsp;</div>
                </div>
            </div>
        </div>
    </div>
</div>
